import { AutoMap } from "@automapper/classes"

export class ELIMSTest {
    @AutoMap()
    TestCode: string = ''
    @AutoMap()
    TestName: string = ''
    @AutoMap()
    ParameterCode: string = ''
    @AutoMap()
    ParameterName: string = ''
    @AutoMap()
    ProductEurodat5Code: string = ''
    @AutoMap()
    PartnerCode: string = ''
    @AutoMap()
    ElimsUnitName : string = ''
    @AutoMap()
    Cas : string = ''
    @AutoMap()
    IncertitudeLOQ! : number
    @AutoMap()
    Loq! : number
    @AutoMap()
    Method : string = ''

}
